import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";
import useLocalStorage from "../../hooks/useLocalStorage";
import { useAddToHomescreenPrompt } from "../../hooks/useTriggerPwaPromt";
import { isIntelled } from "../../services/device";
import { InstallInstruction, VersionTag } from "../../components";
import { API_BASE } from "../../services/api";
import sodennLogo from "../../assets/sodenn.png";
import logout_icon from "../../assets/logout_icon.png";
import styles from "./carnet.module.scss";

const Carnet = () => {
  const [loading, setIsLoading] = useState(false);
  const [member, setMember] = useState({
    id: "",
    fullName: "",
    identifier: "",
    photo: "",
    searchName: "",
  });
  const [storedValue, setValue] = useLocalStorage("identifier");
  const [prompt, promptToInstall] = useAddToHomescreenPrompt();
  const [isVisible, setVisibleState] = useState(false);
  const navigate = useNavigate();

  let { identifier } = useParams(); //"02000004925";

  const LogOut = () => {
    setValue(null);
    navigate("/");
  };

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        let id = identifier || storedValue;
        if (id) {
          let member = await fetch(`${API_BASE}/member/id/${id}`, {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
          });

          member = await member.json();

          setMember({
            fullName: `${member.names} ${member.familyName}`,
            identifier: member.displayidentifier,
            id: member.id,
            photo: member.photo,
            searchName: `${member.names
              .toLowerCase()
              .split(" ")
              .join("-")}-${member.familyName
              .toLowerCase()
              .split(" ")
              .join("-")}`,
          });
        }
      } catch (e) {
        console.log("Error***", e);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [identifier, storedValue]);

  useEffect(() => {
    if (prompt) {
      setVisibleState(true);
    }
  }, [prompt]);

  if (loading) {
    return <p>Is Loading</p>;
  }
 
  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <img src={sodennLogo} className={styles.headerLogo} alt="logo_sodenn" />
      </div>
      <VersionTag/>
      <div className={styles.logout_container}>
        <button className={styles.bunttonless} onClick={LogOut}>
          <img
            src={logout_icon}
            className={styles.logout_icon}
            alt="Logout icon"
          />
        </button>
      </div>
      {prompt && !isIntelled() ? <InstallInstruction /> : null}
      {isVisible ? (
          <button
            className={`${styles.button} ${styles.btn_space}`}
            id="pwa_install"
            onClick={promptToInstall}
          >
            Instalar App
          </button>
        ) : null}
      <div className={styles.innerContainer}>
        <img
          src={member.photo}
          className={styles.profilePhoto}
          alt="foto_miembro"
        />
        <h1 className={styles.fullName}>{member.fullName}</h1>
        <div>
          <h2 className={styles.labelText}>Cédula:</h2>
          <p className={styles.text}>{member.identifier}</p>
        </div>
        <p className={styles.txtBackground}>Puede escanear el código QR o tocar el botón, para visualizar su perfil en la página oficial de SODENN.</p>
        <div className={styles.qrContainer}>
          <a className={styles.linkBtn} href={`https://sodenn.org/perfil/${member.searchName}`}>Ver perfil en directorio</a>
          <QRCode
            size={256}
            style={{ height: "auto", maxWidth: "50%", width: "100%" }}
            value={`https://sodenn.org/perfil/${member.searchName}`}
            viewBox={`0 0 256 256`}
          />
        </div>
        {isVisible ? (
          <button
            className={styles.button}
            id="pwa_install"
            onClick={promptToInstall}
          >
            Instalar App
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default Carnet;
